import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'
import { ALERTS } from 'app/@common/constants'


export default function SelectIkey({...props}) {

    const myProps = {
        urlAjax: ALERTS.IKEYS_LIST,
        label: 'Ikey',
        isClearable: true, firstSelect: false, isMulti: true,
        icon: { icon: 'tag' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}